import React, { useState } from 'react';
import {
	Descriptions,
	Tooltip,
	Typography,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/pro-light-svg-icons';
import Button from '@client/components/Button';
import Modal from '@client/components/Modal/Modal';
import { ESTIMATE_SHORTCUTS } from '../helpers/estimateShortcuts';

const TABLE_NAVIGATION = [
	{ keys: ['Enter'], description: 'Move down' },
	{ keys: ['Shift', 'Enter'], description: 'Move up' },
	{ keys: ['Tab'], description: 'Move right' },
	{ keys: ['Shift', 'Tab'], description: 'Move left' },
	{ keys: ['Esc'], description: 'Undo the changes in the field' },
	{ keys: ['Enter'], description: 'Pick the highlighted option in an open dropdown' },
];

const Keys = ({ keys }: { keys: string[] }) => (
	<>
		{keys.map((key, index) => (
			<React.Fragment key={key}>
				{index > 0 && ' + '}
				<Typography.Text keyboard>{key}</Typography.Text>
			</React.Fragment>
		))}
	</>
);

const KeyboardShortcutsButton = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Tooltip title="Keyboard shortcuts">
				<Button
					type="text"
					onClick={() => setOpen(true)}
					data-testid="keyboard-shortcuts"
					icon={(<FontAwesomeIcon icon={faKeyboard} />)}
				/>
			</Tooltip>
			<Modal
				open={open}
				title="Keyboard shortcuts"
				onCancel={() => setOpen(false)}
				footer={null}
				width={560}
			>
				<Descriptions
					title="Jump to a field"
					extra={(<Typography.Text type="secondary">Alt is Option on Mac</Typography.Text>)}
					column={1}
					size="small"
					bordered
					labelStyle={{ whiteSpace: 'nowrap' }}
				>
					{ESTIMATE_SHORTCUTS.map(({ code, description }) => (
						<Descriptions.Item
							key={code}
							label={(<Keys keys={['Alt', code.replace('Key', '')]} />)}
						>
							{description}
						</Descriptions.Item>
					))}
				</Descriptions>
				<Descriptions
					style={{ marginTop: 24 }}
					title="Tables (port rotation, grid view and Ports)"
					column={1}
					size="small"
					bordered
					labelStyle={{ whiteSpace: 'nowrap' }}
				>
					{TABLE_NAVIGATION.map(({ keys, description }) => (
						<Descriptions.Item
							key={description}
							label={(<Keys keys={keys} />)}
						>
							{description}
						</Descriptions.Item>
					))}
				</Descriptions>
			</Modal>
		</>
	);
};

export default KeyboardShortcutsButton;
